module.exports = __webpack_public_path__ + "img/36.ad225ab6.png";